export default __webpack_public_path__ + "static/media/banner_2500.9d7aaf45.jpg";